import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import DialogCustom from 'commons/DialogCustom';
import Text from 'commons/Text';

import useStyles from './styles';

const RevokeShareLinkDialog = ({ open, onClose, onConfirm, loading }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <DialogCustom
      isShowDialog={open}
      onCancel={onClose}
      onSubmit={onConfirm}
      dialogTitle={t('revoke_link') || 'Revoke link'}
      textCancel={t('no_cancel') || 'No, cancel'}
      textSubmit={t('yes_revoke') || 'Yes, revoke'}
      maxWidth="sm"
      loading={loading}
      PaperProps={{ className: classes.paper }}
      dialogHeaderStyle={classes.dialogHeader}
      dialogContentStyle={classes.dialogContent}
      dialogActionStyle={classes.dialogActions}
      cancelButtonStyle={classes.cancelButton}
      submitButtonStyle={classes.submitButton}
      typeDialogTitle="lg"
    >
      <Box>
        <Text className={classes.description}>
          {t('revoke_link_confirm') ||
            'Are you sure you want to revoke this link? People with this shared link will immediately loose access.'}
        </Text>
      </Box>
    </DialogCustom>
  );
};

export default RevokeShareLinkDialog;
